module.exports = __webpack_public_path__ + "media/components/assets/images/cooingklePackage/image2_dochimom2-4a91b9d8912460e87751011c45838741.png";